/*
FormDate is a v-date-picker based on a calendar to select a data.
Parent components can syncronize their date fields with FormDate as follows:

            <FormDate
              :label="field label"
              v-model="parentDate"
            />
*/
import { format } from '@/plugins/moment'
import validationMixin from '../utils/validationMixin'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

export default {
  name: 'FormDate',
  mixins: [validationMixin, textFieldMixin],

  props: {
    format: {
      type: String,
      default: 'format.date'
    },
    required: Boolean,
    value: String
  },

  data: () => ({
    date: null,
    menu: false
  }),

  created () {
    // expect value from java LocalDate, e.g. 2013-05-30
    this.date = this.value

    // update parent with current value in UTC format
    this.$emit('input', this.date)
  },

  computed: {
    formattedDate () {
      this.$emit('input', this.date)
      return format(this.date, this.$t(this.format), 'YYYY-MM-DD')
    }
  },

  methods: {
    handleDatePickerInput (item, event) {
      this.menu = false
    },

    trigMenu () {
      if (!this.menu) this.menu = true
    },

    clearValue () {
      this.date = null
    }
  },

  watch: {
    value: function (newValue, oldValue) {
      if (newValue !== oldValue && newValue !== this.date) {
        this.date = newValue
      }
    }
  }
}
